var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BriqPagination',{attrs:{"page":_vm.currentPage,"rowsPerTable":_vm.bookingsPerPage,"total":_vm.bookingsCount},on:{"pageSelected":_vm.setPage,"rowsPerTableSelected":_vm.setItemsPerPage}})}
var staticRenderFns = []

export { render, staticRenderFns }